module.exports = __webpack_public_path__ + "static/img/Murray-Taulagi.f0cdfbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Murray-Taulagi.jpg
// module id = k3Aa
// module chunks = 0